import { Divider, Drawer, Input, Space, Slider, Checkbox, Button, Select, Tooltip, Spin } from "antd";
import React, { useState } from "react";
import EditorPanelHeading from "../../UI/EditorPanelHeading";
import PresetPicker from "../../../globals/styles/PresetPicker";
import BMInput from "../../comps/BMInput";
import ImageSelect from "../../ImageSelect";
import PositionAlign from "../../UI/PositionAlign";
import ColourPicker from "../../../globals/styles/ColourPicker";
import { getColor } from "../../../utils/ConvertCSS";
import { useTemplate } from "../../../utils/Template";
import LinkUI from "../../UI/LinkUI";
import ButtonPicker from "../../../globals/styles/ButtonPicker";
import { AlignCenterIcon, AlignLeftIcon, AlignRightIcon, PaddingHorizontalIcon, PaddingVerticalIcon } from "../../Icons";
import Html from "../../../utils/Html";
import { previewLink, tt_name_block_warning, tt_sbs_contain, tt_sbs_padding_x, tt_sbs_padding_y, tt_sbs_txt_padding_x, tt_sbs_txt_padding_y } from "../../../utils/Utils";
import { fetchImage } from "../../../utils/Api";
import RichTextEditor from "../../UI/RichTextEditor";
import SliderInput from "../../UI/SiderInput";
import LinkPicker from "../../../globals/styles/LinkPicker";
import MobileSelector from "../../UI/MobileSelector";
export default function SideBySide(props) {

    const { edit = false, close = () => { }, saveItem = () => { }, deleteItem = () => { }, id = 0, view = "desktop", setView = () => { } } = props;
    const [template,] = useTemplate();
    const [mobile, setMobile] = useState(false)
    const [content, setContent] = useState(props.content);
    const [l, setL] = useState(false)
    const [r, setR] = useState(false);
    const [w, setW] = useState(false);

    const setData = (_data) => {
        setContent({ ...content, "data": _data })
    }

    // Component agnostic
    const {
        name = "",
        container = true,
        data = {},
        date_changed = 0
    } = content;

    // Component specific
    const {
        background_image = "https://bookmanager.com/i/sample_content/placeholder.jpg",
        flip = false,
        background_size = "cover",
        bg_horizontal_align = "center",
        bg_vertical_align = "center",
        text_container = true,
        container_width = 1248,
        container_align = "0 auto",
        text_background_colour = 1,
        text_padding_x = 10,
        text_padding_y = 10,
        background_colour = 0,
        width = 100,
        justify = "center",
        image_width = 50,
        image_height = 50,
        align = "left",
        textAlign = "left",
        padding_x = 10,
        padding_y = 10,
        heading = "Heading...",
        heading_preset = 2,
        paragraph = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque tincidunt enim vel lectus egestas hendrerit. Sed at tempus ante. Interdum et malesuada fames ac ante ipsum primis in faucibus.",
        paragraph_preset = 1,
        button_url = "",
        button_label = "",
        button_type = 1,
        button_tab = true,
        button_block = false,
        background_image_radius = 0,
        link_id = 0,

        // NEW
        image_interior_width = 100,
        image_interior_align = "center",
        image_url = "",
        image_tab = true,

        allow_mobile_overrides = false,
        mobile_flip = false,
        mobile_image_height = 300,
        mobile_bg_horizontal_align = "center",
        mobile_bg_vertical_align = "center",
        mobile_background_size = "cover",



        background_alt = ""

    } = data;

    const save = () => {
        if (!name) {
            let _name = prompt(tt_name_block_warning);
            if (_name) {
                close();
                saveItem(id, { ...content, "name": _name });
            } else {
                return;
            }
        } else {
            close();
            saveItem(id, { ...content })
        }
    }

    const trash = () => {
        deleteItem(id);
        close();
    }

    const linkOut = () => {
        if (button_url) {
            window.open(previewLink(button_url), (button_tab) ? "_blank" : "_self");
        }
    }

    const drawRender = () => {

        let _style = {
            padding: text_padding_y + "px " + text_padding_x + "px",
            maxWidth: width + "%",
            alignSelf: "flex-end",
            textAlign: textAlign,
            flexGrow: 1,
        }

        let bg_style = {
            borderRadius: background_image_radius + "px",
            backgroundRepeat: "no-repeat",
            backgroundPositionX: bg_horizontal_align,
            backgroundPositionY: bg_vertical_align,
            backgroundSize: background_size,
            minHeight: image_height + "px",
            backgroundImage: `url('${fetchImage(background_image)}')`,

        }

        let containerStyle = {
            border: (w) ? "4px solid deeppink" : "none",
            margin: container_align,
            maxWidth: (text_container) ? container_width + "px" : "100%",
            padding: padding_y + "px " + padding_x + "px",

        }

        switch (justify) {
            case "center":
                _style.alignSelf = "center";
                break;
            case "bottom":
                _style.alignSelf = "flex-end";
                break;
            default:
                _style.alignSelf = "flex-start";
                break;
        }

        let _stack = (flip) ? "row" : "row-reverse";

        if (props.view === "phone") {
            _stack = (flip) ? "column" : "column-reverse"
        }

      


        if (r) {
            if (flip) {
                bg_style.borderRight = "4px solid deeppink";
            } else {
                bg_style.borderLeft = "4px solid deeppink";
            }
        }

        // mobile 
        if (allow_mobile_overrides && view !== "desktop") {
            bg_style.minHeight = mobile_image_height + "px";
            _stack = (mobile_flip) ? "column" : "column-reverse";
            bg_style.backgroundPositionX = mobile_bg_horizontal_align;
            bg_style.backgroundPositionY = mobile_bg_vertical_align;
            bg_style.backgroundSize = mobile_background_size;
        }


        return (
            <div id={"bm-" + id} className={(container) ? "preview-container" : ""}>
                <div style={{ background: getColor(background_colour, template) }}>
                    <div style={containerStyle}>
                        <div style={{ display: 'flex', width: '100%', flexDirection: _stack }}>
                            <div style={{ flex: '0 0 ' + image_width + "%", display: 'flex', "justifyContent": image_interior_align }}>
                                <div onClick={() => {
                                    if (image_url) {
                                        window.open(image_url, (image_tab) ? "_blank" : "_self")
                                    }
                                }} style={{ ...bg_style, cursor: (image_url) ? "pointer" : "inherit", "width": image_interior_width + "%" }}></div>
                            </div>
                            <div style={{ flex: '0 0 ' + (100 - image_width) + "%", display: 'flex', justifyContent: align, background: getColor(text_background_colour, template) }}>
                                <div style={{ ..._style, border: (l) ? "4px solid deeppink" : "none" }}>
                                    {(heading &&
                                        <h2 style={{ "display": "block" }} className={"bm-txt-" + heading_preset} >
                                            {heading}
                                        </h2>
                                    )}
                                    {(paragraph &&
                                        <p className={"bm-txt-" + paragraph_preset} >
                                            <Html anchor={"bm-lnkin-" + link_id} html={paragraph} />
                                        </p>
                                    )}
                                    {(button_label &&
                                        <div style={{ "display": "block" }}>
                                            <div className="shim" /><div className="shim" />
                                            <Button block={button_block} onClick={() => linkOut()} className={"bm-btn-" + button_type} >{button_label}</Button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const tipFormatter = (value) => {
        const remaining = 100 - value;
        return `${value} / ${remaining}`;
    };

    const formatter = (value) => `${value}%`;

    const marks = {
        25: <small>25/75</small>,
        50: <small>50/50</small>,
        75: <small>75/25</small>,
    };


    const drawForm = () => {
        return (
            <>
                <EditorPanelHeading menus={props.menus} close={close} trash={trash} save={save} content={content} setContent={setContent} date_changed={date_changed} name={name} />
                {/* BACKGROUND PADDING */}
                <MobileSelector setView={setView} onChange={(e) => setMobile(e)} />
                <div className="shim" /><div className="shim" />
                {(mobile && drawMobile())}
                {(!mobile && drawDesktop())}
            </>
        )
    }

    const drawMobile = () => {
        return (
            <>
                {/* <Divider orientationMargin={0} orientation="left" plain className="simple-divider"><Tooltip title={bg_height}>ENABLED MOBILE OVERIDES?</Tooltip></Divider> */}
                <Checkbox onChange={(e) => setData({ ...data, "allow_mobile_overrides": e.target.checked })} checked={allow_mobile_overrides}><small>Enable Overides?</small></Checkbox>
                <div className="shim" /><div className="shim" />

                <Spin spinning={!allow_mobile_overrides} indicator={<></>}>
                    <Checkbox checked={mobile_flip} onChange={(e) => setData({ ...data, "mobile_flip": e.target.checked })}><small>Flip image & text</small></Checkbox>
                    <div className="shim" /> <div className="shim" />

                    {/* IMAGE WIDTH / HEIGHT */}
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">IMAGE CONTAINER HEIGHT</Divider>

                    <SliderInput
                        width={90}
                        min={0}
                        max={1000}
                        suffix="PX"
                        onChange={(_v) => setData({ ...data, "mobile_image_height": _v })}
                        value={mobile_image_height}
                    />
                    <div className="shim" />

                    {/* IMAGE ALIGN / CONTAIN */}
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">IMAGE BACKGROUND ALIGN / CONTAIN</Divider>
                    <div className="float-flex">
                        <Space>
                            <PositionAlign value={mobile_bg_horizontal_align} onChange={(e) => setData({ ...data, "mobile_bg_horizontal_align": e })} />
                            <PositionAlign value={mobile_bg_vertical_align} type="vertical" onChange={(e) => setData({ ...data, "mobile_bg_vertical_align": e })} />
                        </Space>
                        <div>&nbsp;&nbsp;&nbsp;</div>
                        <Tooltip placement="left" title={tt_sbs_contain}>
                            <Select value={mobile_background_size} onChange={(e) => setData({ ...data, "mobile_background_size": e })} size="small" style={{ "width": "100%" }} >
                                <Select.Option key="cover" value="cover"><small>Cover</small></Select.Option>
                                <Select.Option key="contain" value="contain"><small>Contain</small></Select.Option>
                                <Select.Option key="initial" value="initial"><small>Initial</small></Select.Option>
                            </Select>
                        </Tooltip>
                    </div>
                    <div className="shim" /> <div className="shim" />
                </Spin>
            </>
        )
    }

    const drawDesktop = () => {
        return (
            <>

                {/* MAX WIDTH */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">MAX WIDTH</Divider>
                <div className="float-flex">
                    <SliderInput
                        onBeforeChange={() => setW(true)}
                        onAfterChange={() => setW(false)}
                        width={90}
                        min={0}
                        max={1248}
                        onChange={(_v) => setData({ ...data, "container_width": _v })}
                        disabled={!text_container}
                        value={container_width}
                    />
                    <Checkbox onChange={(e) => setData({ ...data, "text_container": e.target.checked })} checked={text_container}><small>Constrain?</small></Checkbox>
                </div>

                {/* SPLIT */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">IMAGE & TEXT SPLIT</Divider>
                <div className="float-flex">
                    <div className="simple-label"><div className="shim" /><div className="shim" />{(flip) ? "IMAGE" : "TEXT"}</div>
                    <Slider
                        className="rail"
                        onBeforeChange={() => setR(true)}
                        onAfterChange={() => setR(false)}
                        marks={marks}
                        style={{ "width": "160px" }}
                        tipFormatter={tipFormatter}

                        min={20}
                        max={80}
                        onChange={(_v) => setData({ ...data, "image_width": _v })}
                        value={image_width}
                    />
                    <div className="simple-label"><div className="shim" /><div className="shim" />{(flip) ? "TEXT" : "IMAGE"}</div>
                </div>

                <Checkbox checked={flip} onChange={(e) => setData({ ...data, "flip": e.target.checked })}><small>Flip image & text</small></Checkbox>
                <div className="shim" /> <div className="shim" />



                {(text_container &&
                    <>
                        <Divider orientationMargin={0} orientation="left" plain className="simple-divider">ALIGN</Divider>
                        <Space>
                            <div><AlignLeftIcon onClick={() => setData({ ...data, "container_align": "0" })} style={{ "color": (container_align === "0") ? "#1890ff" : "#AAA" }} /></div>
                            <div><AlignCenterIcon onClick={() => setData({ ...data, "container_align": "0 auto" })} style={{ "color": (container_align === "0 auto") ? "#1890ff" : "#AAA" }} /></div>
                            <div><AlignRightIcon onClick={() => setData({ ...data, "container_align": "0 0 0 auto" })} style={{ "color": (container_align === "0 0 0 auto") ? "#1890ff" : "#AAA" }} /></div>
                        </Space>
                    </>
                )}

                {/* BACKGROUND COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND COLOUR</Divider>
                <ColourPicker allow_gradient allow_none value={background_colour} onChange={(_v) => setData({ ...data, "background_colour": _v })} />
                <div className="shim" /> <div className="shim" />
                {/* PADDING FLIP */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PADDING / BORDER RADIUS</Divider>
                <div className="float-flex">
                    <div>
                        <Space>
                            <BMInput value={padding_x} onChange={(_v) => setData({ ...data, "padding_x": _v })} number min={0} max={100} prefix={<Tooltip title={tt_sbs_padding_x}><PaddingHorizontalIcon style={{ "color": "#888" }} /></Tooltip>} />
                            <BMInput value={padding_y} onChange={(_v) => setData({ ...data, "padding_y": _v })} number min={0} max={100} prefix={<Tooltip title={tt_sbs_padding_y}><PaddingVerticalIcon style={{ "color": "#888" }} /></Tooltip>} />
                            <BMInput width={"40px"} value={background_image_radius} onChange={(e) => setData({ ...data, "background_image_radius": e })} number min={0} max={1000} prefix="RADIUS" />
                        </Space>
                    </div>
                </div>
                <div style={{ "margin": "0px -25px" }}><Divider style={{ "margin": "15px 0px" }} /></div>
                {/* BACKGROUND IMAGE */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">IMAGE</Divider>
                <ImageSelect require_alt alt={background_alt} onChange={(_v, _alt) => setData({ ...data, "background_image": _v, "background_alt": _alt })} width={235} path={background_image} />
                <div className="shim" /><div className="shim" />

                {/* BACKGROUND ALT */}
                <div className="shim" />
                <BMInput allow_update value={background_alt} onChange={(e) => setData({ ...data, "background_alt": e })} prefix_width={"50px"} prefix={<nobr>ALT TEXT &nbsp;</nobr>} width={"190px"} placeholder={"Describe the image..."} />
                <div className="shim" /><div className="shim" />

                {/* IMAGE WIDTH / HEIGHT */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">IMAGE WIDTH</Divider>
                <div className="float-flex">
                    <Slider
                        onBeforeChange={() => setL(true)}
                        onAfterChange={() => setL(false)}
                        tooltip={{
                            formatter,
                        }}
                        marks={marks}
                        style={{ "width": "100%" }}
                        min={0}
                        max={100}
                        onChange={(_v) => setData({ ...data, "image_interior_width": _v })}
                        value={image_interior_width}
                    />
                </div>
                <div className="shim" /><div className="shim" />

                {/* IMAGE ALIGN */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">IMAGE ALIGN</Divider>
                <Select value={image_interior_align} onChange={(e) => setData({ ...data, "image_interior_align": e })} size="small" style={{ "width": "100%" }} >
                    <Select.Option key="top" value="flex-start"><small>Left</small></Select.Option>
                    <Select.Option key="center" value="center"><small>Centre</small></Select.Option>
                    <Select.Option key="bottom" value="flex-end"><small>Right</small></Select.Option>
                </Select>
                <div className="shim" /><div className="shim" />


                {/* IMAGE WIDTH / HEIGHT */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">IMAGE CONTAINER HEIGHT</Divider>

                <SliderInput
                    onBeforeChange={() => setW(true)}
                    onAfterChange={() => setW(false)}
                    width={90}
                    min={0}
                    max={1000}
                    suffix="PX"
                    onChange={(_v) => setData({ ...data, "image_height": _v })}
                    value={image_height}
                />
                <div className="shim" />
                {/* IMAGE ALIGN / CONTAIN */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">IMAGE BACKGROUND ALIGN / CONTAIN</Divider>
                <div className="float-flex">
                    <Space>
                        <PositionAlign value={bg_horizontal_align} onChange={(e) => setData({ ...data, "bg_horizontal_align": e })} />
                        <PositionAlign value={bg_vertical_align} type="vertical" onChange={(e) => setData({ ...data, "bg_vertical_align": e })} />
                    </Space>
                    <div>&nbsp;&nbsp;&nbsp;</div>
                    <Tooltip placement="left" title={tt_sbs_contain}>
                        <Select value={background_size} onChange={(e) => setData({ ...data, "background_size": e })} size="small" style={{ "width": "100%" }} >
                            <Select.Option key="cover" value="cover"><small>Cover</small></Select.Option>
                            <Select.Option key="contain" value="contain"><small>Contain</small></Select.Option>
                            <Select.Option key="initial" value="initial"><small>Initial</small></Select.Option>
                        </Select>
                    </Tooltip>
                </div>
                <div className="shim" /> <div className="shim" />

                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">IMAGE LINK URL</Divider>
                <LinkUI value={image_url} onChange={(e) => setData({ ...data, "image_url": e })} />
                <div className="shim" /> <div className="shim" /><div className="shim" /> <div className="shim" />
                <div style={{ "marginTop": "-15px" }} className="float-flex">
                    <div>&nbsp;</div>
                    <Checkbox disabled={(!image_url)} checked={image_tab} onChange={(e) => setData({ ...data, "image_tab": e.target.checked })} ><small>Open in new tab?</small></Checkbox>
                </div>


                <div style={{ "margin": "0px -25px" }}><Divider style={{ "margin": "15px 0px" }} /></div>
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">TEXT WIDTH / POSITION</Divider>
                <div className="float-flex">
                    <Slider
                        onBeforeChange={() => setL(true)}
                        onAfterChange={() => setL(false)}
                        tooltip={{
                            formatter,
                        }}
                        marks={marks}
                        style={{ "width": "100%" }}
                        min={0}
                        max={100}
                        onChange={(_v) => setData({ ...data, "width": _v })}
                        value={width}
                    />
                </div>
                <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">TEXT ALIGN</Divider>
                <div className="float-flex">
                    <Space>
                        <PositionAlign value={align} onChange={(e) => setData({ ...data, "align": e })} />
                        <PositionAlign value={justify} type="vertical" onChange={(e) => setData({ ...data, "justify": e })} />
                    </Space>
                </div>
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">TEXT ALIGN / PADDING</Divider>
                <div className="float-flex">
                    <div>
                        <Space>
                            <div><AlignLeftIcon onClick={() => setData({ ...data, "textAlign": "left" })} style={{ "color": (textAlign === "left") ? "#1890ff" : "#AAA" }} /></div>
                            <div><AlignCenterIcon onClick={() => setData({ ...data, "textAlign": "center" })} style={{ "color": (textAlign === "center") ? "#1890ff" : "#AAA" }} /></div>
                            <div><AlignRightIcon onClick={() => setData({ ...data, "textAlign": "right" })} style={{ "color": (textAlign === "right") ? "#1890ff" : "#AAA" }} /></div>
                        </Space>
                    </div>
                    <Space>
                        <BMInput value={text_padding_x} onChange={(_v) => setData({ ...data, "text_padding_x": _v })} number min={0} max={100} prefix={<Tooltip placement="left" title={tt_sbs_txt_padding_x}><PaddingHorizontalIcon style={{ "color": "#888" }} /></Tooltip>} />
                        <BMInput value={text_padding_y} onChange={(_v) => setData({ ...data, "text_padding_y": _v })} number min={0} max={100} prefix={<Tooltip placement="left" title={tt_sbs_txt_padding_y}><PaddingVerticalIcon style={{ "color": "#888" }} /></Tooltip>} />
                    </Space>
                </div>
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">TEXT BACKGROUND COLOUR</Divider>
                <ColourPicker allow_gradient allow_none value={text_background_colour} onChange={(_v) => setData({ ...data, "text_background_colour": _v })} />
                <div className="shim" /> <div className="shim" />
                <div className="group-wrap">
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">HEADLINE PRESET</Divider>
                    <PresetPicker value={heading_preset} onChange={(e) => setData({ ...data, "heading_preset": e })} />
                    <div className="shim" /> <div className="shim" />
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">HEADLINE</Divider>
                    <Input style={{ "fontSize": "11px" }} onChange={(e) => setData({ ...data, "heading": e.target.value })} value={heading} placeholder="Headline text..." />
                </div>
                <div className="shim" /> <div className="shim" />
                <div className="group-wrap">
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PARAGRAPH PRESET</Divider>
                    <PresetPicker value={paragraph_preset} onChange={(e) => setData({ ...data, "paragraph_preset": e })} />
                    <div className="shim" /> <div className="shim" />
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PARAGRAPH</Divider>
                    <RichTextEditor container={container} link_id={link_id} background_colour={(text_background_colour) ? text_background_colour : background_colour} padding_x={padding_x} padding_y={padding_y} paragraph_preset={paragraph_preset} text_align={textAlign} width={(1248 * (width / 100))} value={paragraph} onChange={(_v) => setData({ ...data, "paragraph": _v })} />
                </div>
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BUTTON LABEL</Divider>
                <Input style={{ "fontSize": "11px" }} onChange={(e) => setData({ ...data, "button_label": e.target.value })} value={button_label} placeholder="Label..." />
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BUTTON TYPE</Divider>
                <ButtonPicker value={button_type} onChange={(e) => setData({ ...data, "button_type": e })} />
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BUTTON URL</Divider>
                <LinkUI value={button_url} onChange={(e) => setData({ ...data, "button_url": e })} />
                <div className="shim" /> <div className="shim" /><div className="shim" /> <div className="shim" />
                <div style={{ "marginTop": "-15px" }} className="float-flex">
                    <Checkbox disabled={(!button_label)} checked={button_block} onChange={(e) => setData({ ...data, "button_block": e.target.checked })} ><small>Fit Container?</small></Checkbox>
                    <Checkbox disabled={(!button_url)} checked={button_tab} onChange={(e) => setData({ ...data, "button_tab": e.target.checked })} ><small>Open in new tab?</small></Checkbox>
                </div>
                <div className="shim" /> <div className="shim" />

                {/* LINK STYLE */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LINK STYLE</Divider>
                <LinkPicker value={link_id} onChange={(e) => setData({ ...data, "link_id": e })} />
                <div className="shim" /> <div className="shim" />
            </>
        )
    }

    return (
        <>
            <Drawer bodyStyle={{ "backgroundColor": "#f5f5f5", "overflowX": "hidden" }} closable={false} width={300} onClose={() => close(true)} open={edit}>
                {drawForm()}
            </Drawer>
            {drawRender()}
        </>
    )

}